export enum StInputEnum{
    Text= 'text',
    Number = 'number',
    Email = 'email',
    Password = 'password',
    Textarea = 'textarea',
    Currency = 'currency',
    Duration = 'duration',
}
